module.exports = __webpack_public_path__ + "static/media/profile-selected.f7815798.svg";